export const PUZZLE_SOURCES = ['lichess', 'user_game'];
export const PUZZLE_GOALS = ['win', 'mate'];
export const PUZZLE_SIDES = ['white', 'black'];
export const PUZZLE_WORLDS = [1, 2, 3, 4];
export const PUZZLE_MISTAKE_KINDS = [
    'too_slow',
    'hangs_piece',
    'wrong_check',
    'wrong_capture',
    'allows_mate'
];
export const DEFAULT_PUZZLE_VOICE = 'puzzlemaster';
//# sourceMappingURL=puzzles.js.map